<template>
  <ul class="selfcheck-button-footer">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'SelfcheckButtonFooter',
}
</script>

<style lang="scss" scoped>
.selfcheck-button-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  margin: 0;

  li {
    width: 48%;
    list-style: none;
  }
}
.button {
  height: 48px;
}
</style>
